'use client';
import React, { useState } from 'react';
import Image from 'next/image';

export default function ProjectGallery({ project_images, orientation }: { project_images: any[], orientation: string }) {
    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const openCarousel = (index: number) => {
        setCurrentIndex(index);
        setIsOpen(true);
    };

    return (
        <div className={`mb-10 text-start col-span-12 grid ${orientation === 'horizontal' ? 'grid-cols-2 md:grid-cols-3' : 'grid-cols-2 md:grid-cols-4'} gap-4`}>
            {project_images?.map((img: any, index: number) => (
                <div
                    key={index}
                    className="relative overflow-hidden cursor-pointer group"
                    onClick={() => openCarousel(index)}
                >
                    <Image
                        src={img?.url}
                        alt={img?.name}
                        width={500}
                        height={500}
                        className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105 aspect-[4/3]" // Set your X/Y ratio here
                    />
                </div>
            ))}

            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-start md:justify-center bg-black/70 backdrop-blur-sm max-w-screen" onClick={() => setIsOpen(false)}>
                    <button onClick={() => setIsOpen(false)} className="absolute top-5 right-5 text-white text-3xl cursor-pointer">✕</button>

                    <button onClick={(e) => {e.stopPropagation(); setCurrentIndex((prev) => (prev > 0 ? prev - 1 : project_images.length - 1))}} className="cursor-pointer absolute left-0 md:left-5 text-gray-300 p-4 text-2xl md:text-5xl">❮</button>

                    <div className="max-w-5xl max-h-[80vh] flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
                        <Image
                            src={project_images[currentIndex].url}
                            width={1200}
                            height={800}
                            className="object-contain max-h-[75vh] max-w-screen"
                            alt="Full view"
                        />
                    </div>

                    <button onClick={(e) => {e.stopPropagation(); setCurrentIndex((prev) => (prev < project_images.length - 1 ? prev + 1 : 0))}} className="cursor-pointer absolute right-0 md:right-5 text-gray-300 p-4 text-2xl md:text-5xl">❯</button>
                </div>
            )}
        </div>
    );
}
